import { AgGrid } from "@jsq/ds/core";

export interface Transaction {
  glTransactionId: number;
  arenaId: number;
  entityId: number | null;
  positionId: number | null;
  effectiveDate: string;
  glDate: string | null;
  totalAmount: string;
  totalConvertedCreditAmount: string;
  transactionCount: number;
  totalShares: string | null;
  totalQuantity: string | null;
  avgCostPerShare: string | null;
  jsqPositionIds: number[] | null;
  transactionCurrency: string;
  debitOrCredit: string | null;
  transactionStatus: string;
  transactionType: string | null;
  transactionDescription: string | null;
  bankAccount: string | null;
  vendor: string | null;
  invoiceNumber: string | null;
  invoiceDueDate: string | null;
  relatedParty: string | null;
  capitalEventReference: string | null;
  sourcesUses: string | null;
  glAccountNumber: string | null;
  glAccountType: string | null;
  dealName: string | null;
  batchType: string | null;
  batchCategory: string | null;
  batchComments: string | null;
  batchReference: string | null;
  batchSourceObjectId: string | null;
  batchCreatedAt: string | null;
  createdAt: string;
  modifiedAt: string | null;
  deletedAt: string | null;
}

export interface TransactionLookupFilters {
  arenaId: string;
  entityId?: number;
  includeDeleted: boolean;
  glDateFrom?: string;
  glDateTo?: string;
  effectiveDateFrom?: string;
  effectiveDateTo?: string;
  status?: string;
  batchSourceObjectId?: string;
  glTransactionType?: string;
  hasMapping?: boolean;
  quickSearch?: string;
}

export interface TransactionDetailRow {
  glBatchSourceObjectId: string | null;
  glBatchDate: string | null;
  glBatchCategory: string | null;
  transactionId: number;
  jsqPositionId: number | null;
  effectiveDate: string;
  transactionAmount: string;
  transactionSourceObjectId: string | null;
  transactionStatus: string;
  transactionIsProcessed: boolean;
  historyEffectiveDate: string;
  historyAmount: string;
  memo: string | null;
  target: string;
  historyBatchCategory: string | null;
  batchCreatedAt: string | null;
  batchModifiedAt: string | null;
  batchDeletedAt: string | null;
  transactionCreatedAt: string;
  transactionModifiedAt: string | null;
  transactionDeletedAt: string | null;
  journalEntryCreatedAt: string;
  journalEntryModifiedAt: string | null;
  journalEntryDeletedAt: string | null;
  historyCreatedAt: string;
  historyModifiedAt: string | null;
  historyDeletedAt: string | null;
}

export type TransactionRowItem = Transaction;

export type TransactionCellRendererParams = AgGrid.ICellRendererParams<TransactionRowItem>;

/** Matches gl-service TransactionStatusType enum values. */
export const TRANSACTION_STATUS = {
  PUBLISHED: "published",
  READY_FOR_REVIEW: "ready_for_review",
  DELETED: "deleted",
  HELD: "held",
  TEST: "test",
} as const;

export type TransactionStatusType =
  (typeof TRANSACTION_STATUS)[keyof typeof TRANSACTION_STATUS];

export const TRANSACTION_STATUS_LABELS: Record<TransactionStatusType, string> = {
  [TRANSACTION_STATUS.PUBLISHED]: "Published",
  [TRANSACTION_STATUS.READY_FOR_REVIEW]: "Ready for Review",
  [TRANSACTION_STATUS.DELETED]: "Deleted",
  [TRANSACTION_STATUS.HELD]: "Held",
  [TRANSACTION_STATUS.TEST]: "Test",
};
